import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    }),
};

@Injectable({
    providedIn: 'root',
})
export class OpenTableService {
    constructor(private http: HttpClient) { }

    cancel(confirmationNumber) {
        return this.http.get(environment.apiV2Path + 'open-table/reservation/cancel/' + confirmationNumber).pipe(map((data: any) => {
            return data;
        }));
    }


    issues() {
        return this.http.get(environment.apiV2Path + 'open-table/issues').pipe(map((data: any) => {
            return data;
        }));
    }

    meta(hotelId): Observable<any> {
        return this.http.get(`${environment.apiV2Path}open-table/availability/meta/${hotelId}`, httpOptions);
    }

    slots(hotelId, dateTime, partySize): Observable<any> {

        return this.http.get(`${environment.apiV2Path}open-table/availability/${hotelId}/${dateTime}/${partySize}`, httpOptions);
    }
    slotLock(tableBooking): Observable<any> {

        const dataToSend = {
            tableBooking,
        }
        return this.http.post(`${environment.apiV2Path}open-table/availability/lock`, dataToSend, httpOptions);
    }
    deleteLock(hotelId, reservationToken): Observable<any> {

        return this.http.delete(`${environment.apiV2Path}open-table/lock/${hotelId}/${reservationToken}`, httpOptions);
    }

    checkDupe(tableBooking): Observable<any> {

        const dataToSend = {
            tableBooking,
        }
        return this.http.post(`${environment.apiV2Path}open-table/availability/checkDupe`, dataToSend, httpOptions);
    }

}
